module.exports = __webpack_public_path__ + "img/facebook-icon.d0a77f3e.svg";